export const licenseKey =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImU4MDljZjFjLWMyOWItNGNhYS05YTJhLWJiY2RjNmI0M2ZmYiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUxCn0=.u360EZfh86c3K/H6UWczBSCKUi/52ZzlqVlhtVSYX5wCgV8heDiiJlbqYB9KuQ6JLDsHOFYAFnEa4+6Ga05WdvyU+Y33jWRv9liP/rQZ4BCK/KqM1XpMOxcuFY42Eg5pKLxA8Q==';
